import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import * as Resources from 'Services/resources/resource';
import { useQuery } from 'react-query';

import { env } from 'Constants';
import { useAuth } from 'Context/auth';
import { Typography } from 'Components/typography';
import { VersionIndicator } from 'Components/version-indicator';

import * as styles from './styles';

/**
 * Component for the page footer
 */
export const PageFooter = ({ className }) => {
  const { isAuthenticated } = useAuth();

  const { data, isLoading } = useQuery(['transport_api_version'],
    () => Resources.list('transport_api_version'),
    { enabled: isAuthenticated });

  const versionDetail = useMemo(() => (
    {
      Server: data?.version,
      UI: env.REACT_APP_ENV !== 'prod' ? `${env.REACT_APP_VERSION}-${env.REACT_APP_ENV}.${env.REACT_APP_VERSION_HASH}` : env.REACT_APP_VERSION,
    }
  ), [data]);

  return (
    <styles.Wrap>
      <div className={`container d-flex items-center justify-between ${className}`}>
        <div style={{ minWidth: '385px' }}>
          <Link to="/" style={{ display: 'inline-block' }}>
            <styles.Logo alt="LTN" />
          </Link>
          <VersionIndicator
            mainVersion={env.REACT_APP_VERSION}
            detailedVerion={versionDetail}
            isLoading={isLoading}
          />
        </div>
        <Typography
          variant="caption"
          style={{
            fontSize: '10px',
            opacity: '.6',
            padding: '0 75px',
            textAlign: 'center',
            height: '46px',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          The content displayed on this website is for customer internal use only. For general
          information visit our company website at https://www.ltnglobal.com or contact us at
          (301) 363-1001 | © 2010-2025 LTN Global Communications, Inc. All rights reserved.
          {!isAuthenticated && (
            <>
              <br />
              Note: This page does not use any cookies.
            </>
          )}
        </Typography>
        <div style={{ minWidth: '300px' }} />
      </div>
    </styles.Wrap>
  );
};
